import { Component } from '@angular/core';

@Component({
  selector: 'app-form-inline-message',
  templateUrl: './form-inline-message.component.html',
  styleUrls: ['./form-inline-message.component.scss'],
})
export class FormInlineMessageComponent {}
